import React, {  } from 'react'
import { useNavigate } from 'react-router-dom'
import { buildHttpPost } from "./utils/backendInterface.js";

const SignUp = () => {
    const navigate = useNavigate();

    const onSubmitHandler = (event) => {
        event.preventDefault();
        console.log('onSubmitHandler SignUp');
        let email = event.target.email.value;
        let password = event.target.password.value;

        let requestParams = new Map();
        requestParams.set("user", email);
        requestParams.set("pass", password);

        function alertContents(httpRequest) {
            if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                console.log("httpRequest.status: " + httpRequest.status);

                if (httpRequest.status === 200) {
                    console.log('Sign up success');

                    sessionStorage.setItem("signUpSuccess", "true");
 
                    navigate('/login');
                } else if (httpRequest.status === 409) {
                    console.log("User already exists. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                    sessionStorage.setItem("signUpSuccess", "false");
                    alert('User already exists');
                } else if (httpRequest.status === 500) {
                    console.log("Internal server error. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                    sessionStorage.setItem("signUpSuccess", "false");
                    alert('User already exists');
                } else {
                    sessionStorage.setItem("signUpSuccess", "false");
                    alert("There was a problem with the request.");
                }
            }
        }

        let httpRequest = buildHttpPost("signup", requestParams, alertContents);
        httpRequest.sendRequest();
    }

    return (
        <>
            <div className="logo-image-container">
                <img src="/logo-small.png" alt="React Logo" />
            </div>
            <form id="sign-up-form" onSubmit={onSubmitHandler}>
                <h3>Sign Up</h3>

                <div className="mb-3">
                    <label>First name</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="First name"
                        name="firstName" />
                </div>
                <div className="mb-3">
                    <label>Last name</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Last name"
                        name="lastName" />
                </div>
                <div className="mb-3">
                    <label>Email address</label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        name="email" />
                </div>
                <div className="mb-3">
                    <label>Password</label>
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password"
                        name="password" />
                </div>
                <div className="d-grid">
                    <button type="submit" className="btn btn-primary">
                        Sign Up
                    </button>
                </div>
                <p className="forgot-password text-right">
                    Already registered <a href="/sign-in">sign in?</a>
                </p>
            </form>
        </>
    );

}

export default SignUp;
